import React, { useState } from "react"
import CheckLegal from "../components/check-legal"

const BlogCommentForm = (props) => {

    // console.log(props);
    const postId = props.postId;
    const provincias = ['Alava', 'Albacete', 'Alicante', 'Almería', 'Asturias', 'Avila', 'Badajoz', 'Barcelona', 'Burgos', 'Cáceres',
        'Cádiz', 'Cantabria', 'Castellón', 'Ciudad Real', 'Córdoba', 'La Coruña', 'Cuenca', 'Gerona', 'Granada', 'Guadalajara',
        'Guipúzcoa', 'Huelva', 'Huesca', 'Islas Baleares', 'Jaén', 'León', 'Lérida', 'Lugo', 'Madrid', 'Málaga', 'Murcia', 'Navarra',
        'Orense', 'Palencia', 'Las Palmas', 'Pontevedra', 'La Rioja', 'Salamanca', 'Segovia', 'Sevilla', 'Soria', 'Tarragona',
        'Santa Cruz de Tenerife', 'Teruel', 'Toledo', 'Valencia', 'Valladolid', 'Vizcaya', 'Zamora', 'Zaragoza'];

    const optionList = provincias.map((item, i) => {
        return (
            <option key={i} value={item}>{item}</option>
        )
    }, this);

    const [serverState, setServerState] = useState({
        submitting: false,
        status: null
    });

    const handleServerResponse = (ok, msg, form) => {
        setServerState({
            submitting: false,
            status: { ok, msg }
        });
        if (ok) {
            form.reset();
        }
    };


    const handleOnSubmit = e => {
        e.preventDefault();
        const form = e.target;
        const [postId, name, email, province, comment] = e.target.elements;
        //console.log(province);
        const data = JSON.stringify({
            post: postId.value,
            author_name: name.value,
            author_email: email.value,
            author_url: province.value,
            content: comment.value,
        });

        fetch("https://blog.brokalia.com/wp-json/wp/v2/comments", {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: data,
        })
            .then((response) => {
                // console.log(response);
                if (response.ok === true) {
                    handleServerResponse(true, "Mensaje enviado correctamente. En breve revisaremos y publicaremos tu comentario.", form);
                }
                else {
                    handleServerResponse(false, "Se ha producido un error enviando el comentario. Inténtalo de nuevo o contacta con el administrador del sitio web.", form);
                }
            })
            .catch(e => {
                // console.log(e);
                handleServerResponse(false, "Se ha producido un error enviando el comentario. Inténtalo de nuevo o contacta con el administrador del sitio web.", form);
            });
    }


    return (
        <section className="bloque-comentarios comentarios-form">
            <h3 className="title">Deja un comentario</h3>
            <p>Tu dirección de correo electrónico no será publicada. Todos los campos son obligatorios.</p>

            <form onSubmit={handleOnSubmit}>
                <input type="hidden" id="postId" value={postId} />


                <div className="form-group">
                    <label className="label-required" htmlFor="name">Nombre</label>
                    <input
                        type="text"
                        className="form-control"
                        id="name"
                        name="name"
                        required
                    />
                </div>
                <div className="form-group">
                    <label className="label-required" htmlFor="email">Email</label>
                    <input
                        type="text"
                        className="form-control"
                        id="email"
                        name="email"
                        required
                    />
                </div>

                <div className="form-group">
                    <label className="label-required" htmlFor="province">Provincia</label>
                    <select id="province" name="province" required className="form-control">
                        <option value="">Selecciona provincia</option>
                        {optionList}
                    </select>
                </div>

                <div className="form-group">
                    <label className="label-required" htmlFor="comment">Mensaje</label>
                    <textarea
                        className="form-control"
                        id="comment"
                        rows="5"
                        name="comment"
                        required
                    >
                    </textarea>
                </div>

                <CheckLegal />

                <button
                    type="submit"
                    className="btn btn-accent"
                    disabled={serverState.submitting}
                >
                    Enviar comentario
                </button>

                {serverState.status && (
                    <p className={!serverState.status.ok ? "errorMsg" : "okMsg"}>
                        {serverState.status.msg}
                    </p>
                )}
            </form>
        </section>
    )
}

export default BlogCommentForm